import { SecondaryButton } from "@graffer-inc/console-design-kit";
import { Shortcut } from "../../../application/domain/ttzk-portal";

type Props = {
  shortcut: Shortcut;
  onPublish: () => void;
  onUnPublish: () => void;
};

export const PublishButton: React.FC<Props> = ({
  shortcut,
  onPublish,
  onUnPublish,
}) => {
  return (
    <>
      {shortcut.isPublished ? (
        <SecondaryButton text={"下書きに戻す"} onClick={() => onUnPublish()} />
      ) : (
        <SecondaryButton text={"公開する"} onClick={() => onPublish()} />
      )}
    </>
  );
};
